import { formatter } from 'utils'

import { useMemberProfiles } from './useMemberProfiles'

const Index = (): JSX.Element => {
  const { memberMemberProfiles } = useMemberProfiles()

  return (
    <>
      {memberMemberProfiles.map((item) => (
        <div key={item.traderId} className="flex flex-col gap-2">
          <p className="text-xs uppercase font-light tracking-wider">
            Batch ID
          </p>
          <p className="font-bold flex gap-2 items-center tracking-wider uppercase">
            {item.batchId || '---'}
          </p>
        </div>
      ))}
    </>
  )
}

export default Index
